import { render, staticRenderFns } from "./XhReceivablesPlan.vue?vue&type=template&id=798829e9&scoped=true"
import script from "./XhReceivablesPlan.vue?vue&type=script&lang=js"
export * from "./XhReceivablesPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798829e9",
  null
  
)

export default component.exports